
import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";
import { useIsMobile } from "@/hooks/use-mobile";
import { Sparkles, Landmark, Home } from "lucide-react";

interface RangeSlidersProps {
  minInvestment: number;
  setMinInvestment: (value: number) => void;
  expectedReturns: number;
  setExpectedReturns: (value: number) => void;
}

export const RangeSliders = ({
  minInvestment,
  setMinInvestment,
  expectedReturns,
  setExpectedReturns,
}: RangeSlidersProps) => {
  const isMobile = useIsMobile();

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('en-GH', {
      style: 'currency',
      currency: 'GHS',
      maximumFractionDigits: 0
    }).format(value);
  };

  return (
    <div className={`grid grid-cols-1 ${isMobile ? 'gap-8' : 'md:grid-cols-2 gap-6'}`}>
      <div className="space-y-4 bg-slate-50 p-4 rounded-lg border border-slate-100">
        <Label className="flex items-center text-slate-700 font-medium">
          <Sparkles className="h-4 w-4 mr-2 text-amber-500" />
          Investment Budget
        </Label>
        <Slider
          value={[minInvestment]}
          onValueChange={([value]) => setMinInvestment(value)}
          max={1000000}
          step={10000}
          className={isMobile ? 'touch-pan-x h-8' : ''}
        />
        <div className="flex justify-between text-sm">
          <span className="text-slate-500">Min</span>
          <span className="font-medium text-slate-900">{formatCurrency(minInvestment)}</span>
          <span className="text-slate-500">Max</span>
        </div>
      </div>

      <div className="space-y-4 bg-slate-50 p-4 rounded-lg border border-slate-100">
        <Label className="flex items-center text-slate-700 font-medium">
          <Home className="h-4 w-4 mr-2 text-green-500" />
          Property Price Range
        </Label>
        <Slider
          value={[expectedReturns]}
          onValueChange={([value]) => setExpectedReturns(value)}
          max={100}
          step={5}
          className={isMobile ? 'touch-pan-x h-8' : ''}
        />
        <div className="flex justify-between text-sm">
          <span className="text-slate-500">Affordable</span>
          <span className="font-medium text-slate-900">
            {formatCurrency(expectedReturns * 10000)}
          </span>
          <span className="text-slate-500">Luxury</span>
        </div>
      </div>
    </div>
  );
};
